export default __webpack_public_path__ + "static/media/5.053e8481.png";